import { Component, computed, input } from '@angular/core';
import type { OnyxColor } from '@onyx/angular';
import type { SwapPoint } from '../../../../../../fleet/common/interfaces/technical-point';
import { SwapVehicleType } from '../../../../enums/swap/swap-vehicle-type';
import type { Swap } from '../../../../interfaces/swap/swap';
import { SwapModalSummaryItemDetailsComponent } from './swap-modal-summary-item-details/swap-modal-summary-item-details.component';
import { SwapModalSummaryItemStatusComponent } from './swap-modal-summary-item-status/swap-modal-summary-item-status.component';
import { SwapModalSummaryItemUnassignedPointsComponent } from './swap-modal-summary-item-unassigned-points/swap-modal-summary-item-unassigned-points.component';

@Component({
  selector: 'app-swap-modal-summary-item',
  imports: [
    SwapModalSummaryItemStatusComponent,
    SwapModalSummaryItemDetailsComponent,
    SwapModalSummaryItemUnassignedPointsComponent,
  ],
  templateUrl: './swap-modal-summary-item.component.html',
  styleUrl: './swap-modal-summary-item.component.scss',
  host: {
    '[class.single]': `!isDouble()`,
  },
})
export class SwapModalSummaryItemComponent {
  public readonly type = input.required<SwapVehicleType>();
  public readonly swap = input.required<Swap>();
  public readonly technicalPoints = input.required<SwapPoint[]>();
  public readonly isDouble = input.required<boolean>();
  public readonly identifierColor = input.required<OnyxColor | null>();

  protected swapPoint = computed(
    () =>
      this.technicalPoints().at(
        this.type() === SwapVehicleType.PRIMARY ? 0 : 1,
      ) ?? null,
  );
}
